<template>
  <Modal v-model="visible" :width="720" class-name="cq-script-modal" :closable="true" :mask-closable="false" footer-hide>
    <div class="cq-script-head">
      <Icon type="ios-code-working" class="cq-script-icon" />
      <span class="cq-script-title">查询脚本</span>
    </div>

    <div class="cq-script-body">
      <Spin fix v-if="loading">加载中...</Spin>

      <Tabs v-model="activeTab" class="cq-script-tabs">
        <TabPane label="标准SQL" name="sql">
          <div class="cq-script-block">
            <div class="cq-script-toolbar">
              <Button size="small" icon="md-copy" @click="copy(sql)">复制</Button>
            </div>
            <pre class="cq-script-code" v-if="sql">{{ sql }}</pre>
            <p class="cq-script-empty" v-else>暂无标准SQL</p>
          </div>
        </TabPane>
        <TabPane label="调试SQL" name="debugSql">
          <div class="cq-script-block">
            <div class="cq-script-toolbar">
              <Button size="small" icon="md-copy" @click="copy(debugSql)">复制</Button>
            </div>
            <pre class="cq-script-code" v-if="debugSql">{{ debugSql }}</pre>
            <p class="cq-script-empty" v-else>暂无调试SQL</p>
          </div>
        </TabPane>
      </Tabs>
    </div>

    <div class="cq-script-footer">
      <Button @click="visible = false">关闭</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'script-modal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    api: {
      type: Object,
      required: true
    },
    // 查询配置（queryJson，对象或字符串）
    queryJson: {
      type: [Object, String, Array],
      default: null
    },
    // 应用ID（可选，接口层会兜底解析）
    appId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: this.value,
      loading: false,
      activeTab: 'sql',
      sql: '',
      debugSql: ''
    }
  },
  watch: {
    value(val) {
      this.visible = val
      if (val) {
        this.activeTab = 'sql'
        this.fetchScript()
      }
    },
    visible(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    fetchScript() {
      if (typeof this.api.getQueryScript !== 'function') {
        this.$Message.info('查看脚本功能待接入')
        return
      }
      this.loading = true
      this.sql = ''
      this.debugSql = ''
      Promise.resolve(this.api.getQueryScript({ appId: this.appId, queryJson: this.queryJson }))
        .then(resp => {
          resp = resp || {}
          console.log('getQueryScript resp:', resp)
          if (resp.success === false) {
            this.$Message.error(resp.msg || '获取脚本失败')
          }
          this.sql = resp.sql || ''
          this.debugSql = resp.debugSql || ''
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$Message.error((err && err.message) || '获取脚本失败')
        })
    },
    copy(text) {
      text = text || ''
      if (!text) {
        this.$Message.info('暂无可复制内容')
        return
      }
      // 优先使用剪贴板 API，失败时回退 execCommand
      let done = () => this.$Message.success('已复制到剪贴板')
      let fail = () => this.$Message.error('复制失败，请手动选择复制')
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done, fail))
      } else {
        this.fallbackCopy(text, done, fail)
      }
    },
    fallbackCopy(text, done, fail) {
      let ta = document.createElement('textarea')
      ta.value = text
      ta.style.position = 'fixed'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy') ? done() : fail()
      } catch (e) {
        fail()
      }
      document.body.removeChild(ta)
    }
  }
}
</script>

<style lang="less" scoped>
.cq-script-head {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.cq-script-icon {
  font-size: 22px;
  color: #2b5fd9;
  margin-right: 8px;
}
.cq-script-title {
  font-size: 18px;
  font-weight: 600;
}
.cq-script-body {
  position: relative;
  min-height: 160px;
}
.cq-script-block {
  position: relative;
}
.cq-script-toolbar {
  text-align: right;
  margin-bottom: 8px;
}
.cq-script-code {
  margin: 0;
  padding: 12px 14px;
  max-height: 46vh;
  overflow: auto;
  background: #282c34;
  color: #abb2bf;
  border-radius: 4px;
  font-family: 'Consolas', 'Monaco', 'Menlo', monospace;
  font-size: 13px;
  line-height: 20px;
  white-space: pre-wrap;
  word-break: break-all;
}
.cq-script-empty {
  padding: 24px 0;
  text-align: center;
  color: #999;
  font-size: 13px;
}
.cq-script-footer {
  text-align: right;
  margin-top: 14px;
}
</style>



// WEBPACK FOOTER //
// src/component/data-grid/custom-query/components/script-modal.vue